export default __webpack_public_path__ + "static/tiempos-text-web-regular-943fb4c19267fc3c5668a44037befeeb.woff2";